import type { PhaseKey, ExerciseTemplateDTO, ExerciseTemplate } from "@akina/domain";
import { toCamelCase } from "@akina/utils";
import type { ExerciseTemplateList, ExerciseTemplateListApi } from "types/schemas";
import { type AppLocale } from "../locales";
import { exerciseTemplateMapper } from "../mappers";
import { type ApiConfiguration, ApiMethod } from "./shared";

export const templateApi = (config: ApiConfiguration) => ({
  async getExerciseSummaries(locale: string): Promise<ExerciseTemplateList> {
    const result = await config.httpService.fetch<ExerciseTemplateListApi>({
      method: ApiMethod.GET,
      url: config.endpoints.treatments.getExerciseSummaries(locale),
    });

    return toCamelCase(result);
  },
  async getExerciseTemplate({
    treatmentTemplateKey,
    exerciseTemplateKey,
    phaseKey,
    language,
  }: {
    treatmentTemplateKey: string;
    exerciseTemplateKey: string;
    phaseKey: PhaseKey;
    language: AppLocale;
  }): Promise<ExerciseTemplate> {
    const result = await config.httpService.fetch<ExerciseTemplateDTO>({
      method: ApiMethod.GET,
      url: config.endpoints.treatments.getExerciseTemplate(
        treatmentTemplateKey,
        exerciseTemplateKey,
        phaseKey,
        language,
      ),
    });

    return exerciseTemplateMapper.toDomain(result);
  },
});
